module.exports = __webpack_public_path__ + "img/login.290e0e52.jpg";